<template>
  <div>
    <LoadingBarComponent
      v-show="currentUserLoading"
      loading-text="Loading User"/>
    <v-scale-transition hide-on-leave>
      <div v-if="currentUserData !== null || currentUserError !== null">
        <v-alert v-if="currentUserError !== null" text dense type="error">
          {{ currentUserError }}
        </v-alert>
        <div v-if="currentUserData !== null">
          <div class="d-flex align-center">
            <v-card-title><v-icon class="mr-3">mdi-account</v-icon>{{ currentUserData.email }}</v-card-title>
            <v-spacer/>
            <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <UserSubscriptionsList
            :user-id="currentUserData.id"
            :user-subscriptions="userSubscriptionsData"
            :error="userSubscriptionError"
            :loading="userSubscriptionLoading"/>
        </div>
      </div>
    </v-scale-transition>
  </div>
</template>

<script>
import UserSubscriptionsList from '../components/user/UserSubscriptionsList'
import LoadingBarComponent from '../components/LoadingBarComponent'

export default {
  name: 'User',
  components: {
    UserSubscriptionsList,
    LoadingBarComponent
  },
  created () {
    this.$store.dispatch('user/fetchUser', { customerId: this.$route.params.customerId, userId: this.$route.params.userId }).then(() => {
      this.$store.dispatch('user/fetchUserSubscriptions', { customerId: this.$route.params.customerId, userId: this.$route.params.userId })
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (from.params.userId !== to.params.userId) {
      this.$store.dispatch('user/resetCurrentUser')
      this.$store.dispatch('user/fetchUser', { customerId: to.params.customerId, userId: to.params.userId }).then(() => {
        next()
        this.$store.dispatch('user/fetchUserSubscriptions', { customerId: to.params.customerId, userId: to.params.userId })
      })
    } else {
      next(false)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('user/resetCurrentUser')
    next()
  },
  methods: {
    goBack: function () {
      let self = this
      this.$router.push({ name: 'customer', params: { customerId: self.customer.id } })
    }
  },
  computed: {
    currentUserData: function () {
      return this.$store.state.user.currentUser.data
    },
    currentUserError: function () {
      return this.$store.state.user.currentUser.error
    },
    currentUserLoading: function () {
      return this.$store.state.user.currentUser.data === null && this.$store.state.user.currentUser.error === null
    },
    customer: function () {
      return this.$store.state.customer.currentCustomer.data
    },
    userSubscriptionsData: function () {
      return this.$store.state.user.allSubscriptions.data === null ? [] : this.$store.state.user.allSubscriptions.data
    },
    userSubscriptionError: function () {
      return this.$store.state.user.allSubscriptions.error
    },
    userSubscriptionLoading: function () {
      return this.$store.state.user.allSubscriptions.data === null && this.$store.state.user.allSubscriptions.error === null
    }
  }
}

</script>

<style scoped>

</style>
